var map = {
	"./ac.svg": 90000,
	"./ad.svg": 9889,
	"./ae.svg": 71916,
	"./af.svg": 69186,
	"./ag.svg": 71766,
	"./ai.svg": 98650,
	"./al.svg": 63513,
	"./am.svg": 14861,
	"./ao.svg": 18599,
	"./aq.svg": 30791,
	"./ar.svg": 73034,
	"./as.svg": 94156,
	"./at.svg": 72448,
	"./au.svg": 38549,
	"./aw.svg": 33587,
	"./ax.svg": 42532,
	"./az.svg": 78168,
	"./ba.svg": 32446,
	"./bb.svg": 12060,
	"./bd.svg": 36865,
	"./be.svg": 49684,
	"./bf.svg": 24433,
	"./bg.svg": 30672,
	"./bh.svg": 19648,
	"./bi.svg": 54928,
	"./bj.svg": 33419,
	"./bl.svg": 50022,
	"./bm.svg": 71710,
	"./bn.svg": 69062,
	"./bo.svg": 25957,
	"./bq.svg": 76554,
	"./br.svg": 96459,
	"./bs.svg": 59346,
	"./bt.svg": 28088,
	"./bv.svg": 9442,
	"./bw.svg": 30684,
	"./by.svg": 80764,
	"./bz.svg": 47984,
	"./ca.svg": 72279,
	"./cc.svg": 90590,
	"./cd.svg": 14998,
	"./cefta.svg": 11513,
	"./cf.svg": 26365,
	"./cg.svg": 8775,
	"./ch.svg": 47809,
	"./china.svg": 57823,
	"./ci.svg": 21206,
	"./ck.svg": 5255,
	"./cl.svg": 5316,
	"./cm.svg": 41447,
	"./cn.svg": 38422,
	"./co.svg": 99932,
	"./cp.svg": 24763,
	"./cr.svg": 91770,
	"./cu.svg": 40621,
	"./cv.svg": 21312,
	"./cw.svg": 64935,
	"./cx.svg": 81107,
	"./cy.svg": 6642,
	"./cz.svg": 61107,
	"./de.svg": 60264,
	"./dg.svg": 77542,
	"./dj.svg": 7415,
	"./dk.svg": 84926,
	"./dm.svg": 79329,
	"./do.svg": 37347,
	"./dz.svg": 14645,
	"./ea.svg": 43013,
	"./ec.svg": 4835,
	"./ee.svg": 68745,
	"./eg.svg": 24963,
	"./eh.svg": 44915,
	"./er.svg": 43550,
	"./es-ct.svg": 86326,
	"./es-ga.svg": 67325,
	"./es.svg": 1771,
	"./et.svg": 53861,
	"./eu.svg": 82626,
	"./fi.svg": 36373,
	"./fj.svg": 49118,
	"./fk.svg": 9108,
	"./fm.svg": 75586,
	"./fo.svg": 44940,
	"./fr.svg": 59986,
	"./french.svg": 60036,
	"./ga.svg": 28979,
	"./gb-eng.svg": 93630,
	"./gb-nir.svg": 3110,
	"./gb-sct.svg": 61583,
	"./gb-wls.svg": 16868,
	"./gb.svg": 41517,
	"./gd.svg": 78678,
	"./ge.svg": 17706,
	"./germany.svg": 76370,
	"./gf.svg": 22920,
	"./gg.svg": 20795,
	"./gh.svg": 41867,
	"./gi.svg": 47323,
	"./gl.svg": 19522,
	"./gm.svg": 11199,
	"./gn.svg": 9923,
	"./gp.svg": 78670,
	"./gq.svg": 44798,
	"./gr.svg": 99277,
	"./gs.svg": 228,
	"./gt.svg": 94161,
	"./gu.svg": 60167,
	"./gw.svg": 14233,
	"./gy.svg": 92335,
	"./hk.svg": 16039,
	"./hm.svg": 12280,
	"./hn.svg": 12494,
	"./hr.svg": 36810,
	"./ht.svg": 51312,
	"./hu.svg": 15379,
	"./ic.svg": 33612,
	"./id.svg": 39627,
	"./ie.svg": 79849,
	"./il.svg": 60937,
	"./im.svg": 43567,
	"./in.svg": 17985,
	"./io.svg": 67884,
	"./iq.svg": 75045,
	"./ir.svg": 51685,
	"./is.svg": 30784,
	"./it.svg": 64882,
	"./italy.svg": 74289,
	"./je.svg": 53592,
	"./jm.svg": 34214,
	"./jo.svg": 4122,
	"./jp.svg": 60807,
	"./ke.svg": 96601,
	"./kg.svg": 97338,
	"./kh.svg": 29741,
	"./ki.svg": 86891,
	"./km.svg": 90923,
	"./kn.svg": 87151,
	"./kp.svg": 71447,
	"./kr.svg": 52771,
	"./kw.svg": 38180,
	"./ky.svg": 27706,
	"./kz.svg": 77733,
	"./la.svg": 75367,
	"./lb.svg": 37781,
	"./lc.svg": 7976,
	"./li.svg": 88413,
	"./lk.svg": 87054,
	"./lr.svg": 17695,
	"./ls.svg": 18277,
	"./lt.svg": 46259,
	"./lu.svg": 320,
	"./lv.svg": 63219,
	"./ly.svg": 43864,
	"./ma.svg": 99455,
	"./mc.svg": 44337,
	"./md.svg": 26554,
	"./me.svg": 27490,
	"./mf.svg": 19815,
	"./mg.svg": 35064,
	"./mh.svg": 85381,
	"./mk.svg": 81664,
	"./ml.svg": 56723,
	"./mm.svg": 3852,
	"./mn.svg": 32527,
	"./mo.svg": 34822,
	"./mp.svg": 28967,
	"./mq.svg": 32453,
	"./mr.svg": 38986,
	"./ms.svg": 21998,
	"./mt.svg": 68295,
	"./mu.svg": 43504,
	"./mv.svg": 95338,
	"./mw.svg": 72877,
	"./mx.svg": 44837,
	"./my.svg": 44273,
	"./mz.svg": 93363,
	"./na.svg": 89693,
	"./nc.svg": 22393,
	"./ne.svg": 70906,
	"./nf.svg": 27289,
	"./ng.svg": 92618,
	"./ni.svg": 48419,
	"./nl.svg": 23648,
	"./no.svg": 69220,
	"./np.svg": 75433,
	"./nr.svg": 11990,
	"./nu.svg": 11830,
	"./nz.svg": 15810,
	"./om.svg": 9811,
	"./pa.svg": 72241,
	"./pe.svg": 3858,
	"./pf.svg": 38307,
	"./pg.svg": 38792,
	"./ph.svg": 3404,
	"./pk.svg": 21576,
	"./pl.svg": 12527,
	"./pm.svg": 80334,
	"./pn.svg": 12061,
	"./pr.svg": 30921,
	"./ps.svg": 43581,
	"./pt.svg": 93591,
	"./pw.svg": 48808,
	"./py.svg": 20082,
	"./qa.svg": 896,
	"./re.svg": 76654,
	"./ro.svg": 19061,
	"./rs.svg": 31384,
	"./ru.svg": 31561,
	"./russia.svg": 76688,
	"./rw.svg": 25589,
	"./sa.svg": 4806,
	"./sb.svg": 57753,
	"./sc.svg": 82246,
	"./sd.svg": 9509,
	"./se.svg": 65316,
	"./sg.svg": 38966,
	"./sh.svg": 90370,
	"./si.svg": 43035,
	"./sj.svg": 82406,
	"./sk.svg": 51977,
	"./sl.svg": 13331,
	"./sm.svg": 28199,
	"./sn.svg": 95341,
	"./so.svg": 59515,
	"./spain.svg": 35559,
	"./sr.svg": 72221,
	"./ss.svg": 9626,
	"./st.svg": 6754,
	"./sv.svg": 70649,
	"./sx.svg": 89782,
	"./sy.svg": 12638,
	"./sz.svg": 85878,
	"./ta.svg": 36090,
	"./tc.svg": 46583,
	"./td.svg": 57021,
	"./tf.svg": 33928,
	"./tg.svg": 87086,
	"./th.svg": 59341,
	"./tj.svg": 19255,
	"./tk.svg": 17285,
	"./tl.svg": 14776,
	"./tm.svg": 44993,
	"./tn.svg": 30393,
	"./to.svg": 18314,
	"./tr.svg": 36686,
	"./tt.svg": 98345,
	"./tv.svg": 93406,
	"./tw.svg": 27251,
	"./tz.svg": 9645,
	"./ua.svg": 64558,
	"./ug.svg": 71593,
	"./um.svg": 21095,
	"./un.svg": 96428,
	"./us.svg": 84679,
	"./uy.svg": 68365,
	"./uz.svg": 22732,
	"./va.svg": 23873,
	"./vc.svg": 52326,
	"./ve.svg": 72445,
	"./vg.svg": 5208,
	"./vi.svg": 9153,
	"./vn.svg": 35869,
	"./vu.svg": 97435,
	"./wf.svg": 9350,
	"./ws.svg": 6348,
	"./xk.svg": 14656,
	"./xx.svg": 4176,
	"./ye.svg": 79870,
	"./yt.svg": 5339,
	"./za.svg": 36979,
	"./zm.svg": 7995,
	"./zw.svg": 46931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96558;